import { render } from "./BlogListPage.vue?vue&type=template&id=c27e8a10&scoped=true"
import script from "./BlogListPage.vue?vue&type=script&lang=js"
export * from "./BlogListPage.vue?vue&type=script&lang=js"

import "./BlogListPage.vue?vue&type=style&index=0&id=c27e8a10&scoped=true&lang=css"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27e8a10"]])

export default __exports__